import { AwardEmbeds, ListAwardsParams, listAwards } from '@kudos/http-client'
import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

export const ALL_AWARDS_QUERY_KEY = 'ALL_AWARDS'

export const awardEmbeds: AwardEmbeds[] = [
  'recipientCount',
  'badgeUrls',
  'sendToAndSender',
  'comments',
  'reactionCounts',
  'endorsementStats',
]

const listAwardsDefaultParams: ListAwardsParams = {
  page: 1,
  pageSize: 20,
  sorting: ['-publishedAt'],
  embeds: awardEmbeds,
}

const usePaginatedAwardsData = (
  options: ListAwardsParams = listAwardsDefaultParams,
  enabled = true,
) => {
  const { recipientIdIn, idIn, senderIdIn, embeds, pageSize, sorting } = options

  const { data, fetchNextPage, isFetched, isFetchingNextPage, hasNextPage } = useInfiniteQuery({
    queryKey: [ALL_AWARDS_QUERY_KEY, idIn, recipientIdIn, senderIdIn],
    queryFn: ({ pageParam = 1 }) =>
      listAwards({
        ...{ idIn: idIn },
        ...{ recipientIdIn: recipientIdIn },
        ...{ senderIdIn: senderIdIn },
        page: pageParam,
        pageSize,
        sorting,
        embeds,
      }),
    initialPageParam: 1,
    getNextPageParam: lastPage => lastPage.next,
    enabled,
    placeholderData: keepPreviousData,
  })

  const awardsData = useMemo(() => {
    return data ? data.pages.flatMap(page => page.results) : []
  }, [data])

  return { awardsData, hasNextPage, fetchNextPage, isFetched, isFetchingNextPage }
}

export default usePaginatedAwardsData
